import axios from 'axios';
import { PRODUCTS_URL } from '../../layouts/API';

const GetAllProductsSlice = async (data, token) => {
	let headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};

	let response = await axios({
		method: 'GET',
		baseURL: `${PRODUCTS_URL}`,
		headers: headers,
		props: { ...data },
	});
	return response.data;
};

const GetAllProductsTypesSlice = async (data, token) => {
	let headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};

	let response = await axios({
		method: 'GET',
		baseURL: `${PRODUCTS_URL}/types`,
		headers: headers,
		props: { ...data },
	});
	return response.data;
};

const GetSingleProductsSlice = async (product_id, token) => {
	let headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};

	let response = await axios({
		method: 'GET',
		baseURL: `${PRODUCTS_URL}/${product_id}`,
		headers: headers,
	});
	return response.data;
};

const CreateProductMethod = async (data, token) => {
	let headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};

	let response = await axios({
		method: 'POST',
		baseURL: `${PRODUCTS_URL}/create`,
		headers: headers,
		data: data,
	});
	return response.data;
};

const UpdateProductMethod = async (data, token) => {
	let headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	};

	let response = await axios({
		method: 'POST',
		baseURL: `${PRODUCTS_URL}/update`,
		headers: headers,
		data: data,
	});
	return response.data;
};

const DeleteProductSlice = async (product_id, token) => {
	let headers = {
		Accept: 'aplication/json',
		Authorization: `Bearer ${token}`,
	};

	let response = await axios({
		method: 'GET',
		baseURL: `${PRODUCTS_URL}/delete/${product_id}`,
		headers: headers,
	});
	return response.data;
};

const ProductService = {
	GetAllProductsSlice,
	GetAllProductsTypesSlice,
	GetSingleProductsSlice,
	CreateProductMethod,
	UpdateProductMethod,
	DeleteProductSlice,
};

export default ProductService;
